<template>
  <v-app>
    <LoadingSpinner v-if="authorizing" />
    <template v-else-if="authError">
      {{ authError }}
    </template>
    <template v-else-if="authorized">
      <app-bar />
      <left-navigation />
      <v-main>
        <v-container
          fluid
          class="h-full"
        >
          <router-view :key="routeKey" />
        </v-container>
        <PrintJobDetailDrawer />
        <PromoJobDetailDrawer />
        <PrintJobAddExternalJob />
        <PrintJobAddTracking />
        <PrintJobSyncProject />
        <PrintJobEditAddress />
        <PrintJobValidate />
        <CacheSync />
      </v-main>
    </template>
    <alert ref="alert" />
    <confirm ref="confirm" />
    <Clipboard ref="clipboard" />
    <v-snackbar
      ref="snackbar"
      v-model="snackbar"
      timeout="5000"
      :color="snackbarColor"
      top
      class="font-weight-bold"
    >
      <v-icon
        v-if="snackbarIcon"
        dark
      >
        {{ snackbarIcon }}
      </v-icon>
      {{ snackbarText }}
      <template #action="{ attrs }">
        <v-btn
          dark
          icon
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Clipboard from '@/components/Clipboard';
import CacheSync from '@/components/common/CacheSync';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import Alert from '@/components/layout/Alert';
import AppBar from '@/components/layout/AppBar';
import Confirm from '@/components/layout/Confirm';
import LeftNavigation from '@/components/layout/LeftNavigation';
import PrintJobDetailDrawer from '@/components/orders/print/DetailDrawer';
import PromoJobDetailDrawer from '@/components/orders/promo/DetailDrawer';
import PrintJobAddExternalJob from '@/components/print/job/AddExternalJob';
import PrintJobAddTracking from '@/components/print/job/AddTracking';
import PrintJobEditAddress from '@/components/print/job/EditAddress';
import PrintJobSyncProject from '@/components/print/job/SyncProject';
import PrintJobValidate from '@/components/print/job/Validate';
import { mapGetters } from 'vuex';
export default {
  name: 'App',

  components: {
    LoadingSpinner,
    'app-bar': AppBar,
    alert: Alert,
    confirm: Confirm,
    LeftNavigation,
    PrintJobDetailDrawer,
    PromoJobDetailDrawer,
    Clipboard,
    CacheSync,
    PrintJobAddExternalJob,
    PrintJobAddTracking,
    PrintJobSyncProject,
    PrintJobEditAddress,
    PrintJobValidate
  },
  data: () => ({
    snackbar: false,
    snackbarColor: 'success',
    snackbarText: '',
    snackbarIcon: '',
    authorizing: false,
    authError: ''
  }),
  computed: {
    routeKey() {
      return this.$store.state.config.routeKey;
    },
    hideDefaultNavigation: function () {
      return this.$route.meta.hideDefaultNavigation;
    },
    ...mapGetters({
      authorized: 'auth/authorized',
      topDrawer: 'drawers/topDrawer'
    })
  },
  watch: {
    topDrawer(val) {
      if (val?.id) {
        this.$nextTick(() => {
          document.documentElement.classList.add('overflow-hidden');
        });
      } else {
        document.documentElement.classList.remove('overflow-hidden');
      }
    }
  },

  mounted() {
    var timeout = setTimeout(() => {
      this.authorizing = true;
    }, 1000);
    this.$store
      .dispatch('auth/authorize')
      .then(() => {
        this.$root.$alert = this.$refs.alert.open;
        this.$root.$confirm = this.$refs.confirm.open;
        this.$root.$snackbar = this.openSnackbar;
        this.$root.$snackbarSuccess = this.openSnackbarSuccess;
        this.$root.$snackbarError = this.openSnackbarError;
        this.$root.$clipboard = this.$refs.clipboard.copy;
        this.loadData();
      })
      .catch((error) => {
        this.logError(error, true);
        this.authError = 'Forbidden';
      })
      .finally(() => {
        if (timeout) window.clearTimeout(timeout);
        this.authorizing = false;
      });
  },

  methods: {
    loadData() {
      this.$store.dispatch('lookup/get');
    },
    openSnackbar(text, color, icon) {
      this.snackbarText = text;
      this.snackbarColor = color || 'success';
      this.snackbar = true;
      this.snackbarIcon = icon;
    },
    openSnackbarSuccess(text) {
      this.openSnackbar(text, 'success', 'check-circle');
    },
    openSnackbarError(text) {
      this.openSnackbar(text, 'error', 'cancel');
    },
    clearRunAs() {}
  }
};
</script>

<style lang="scss">
@import 'src/scss/main.scss';
</style>
